import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ChatProvider } from "./contexts/ChatContext";
import ThemeProvider from "./contexts/ThemeContext";
import LanguageProvider from "./contexts/LanguageContext";
import LoginPage from "./pages/LoginPage";
import ChatPage from "./pages/ChatPage";
import SignUpPage from "./pages/SignUpPage";
import VerificationPage from "./pages/VerificationPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";

const App = () => {
  const [currentPage, setCurrentPage] = useState("login");
  const [currentEmail, setCurrentEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleNavigate = (data) => {
    if (typeof data === "string") {
      setCurrentPage(data);
      if (data === "login") setSuccessMessage(""); // Başarı mesajını temizle
    } else {
      setCurrentPage(data.page);
      if (data.email) setCurrentEmail(data.email);
      if (data.message) setSuccessMessage(data.message); // Başarı mesajını ayarla
    }
  };

  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <ChatProvider>
            <LanguageProvider>
            <Routes>
              <Route path="/chat/login" element={ <LoginPage successMessage={successMessage} />} />
              <Route path="/chat/home" element={ <ChatPage />} />
              <Route path="/chat/signup" element={ <SignUpPage />} />
              <Route path="/chat/verification" element={ <VerificationPage email={currentEmail}  />} />
              <Route path="/chat/forgot-password" element={ <ForgotPasswordPage />} />
              <Route path="/chat/reset-password" element={ <ResetPasswordPage email={currentEmail}  />} />
              <Route path="/chat/change-password" element={ <ChangePasswordPage  />} />
              </Routes>
            </LanguageProvider>
          </ChatProvider>
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
};



export default App;